import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function FraudTab() {
  const [rows, setRows] = useState([]);
  const [tab, setTab] = useState("open");
  async function load(status) { const r = await api.get(`/fraud?status=${status}`); setRows(r.data); }
  useEffect(() => { load(tab); }, [tab]);

  async function resolve(id, next) {
    await api.patch(`/fraud/${id}?status=${next}`);
    toast.success("Flag updated");
    load(tab);
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="display-heading font-black text-3xl">Fraud Flags</h2>
        <div className="kbd-label text-white/40 mt-1">HEURISTIC SIGNALS · REVIEW QUEUE</div>
      </div>
      <div className="flex gap-2">
        {["open", "resolved", "dismissed"].map(s => (
          <button key={s} onClick={() => setTab(s)} className={`px-3 py-1 kbd-label border ${tab === s ? "border-neon-cyan text-neon-cyan" : "border-white/10 text-white/60"}`}>{s.toUpperCase()}</button>
        ))}
      </div>
      <div className="card-tactical overflow-x-auto">
        <table className="w-full text-sm font-mono">
          <thead>
            <tr className="kbd-label text-left text-white/50 border-b border-white/10">
              <th className="px-6 py-3">WHEN</th><th>TYPE</th><th>CODE</th><th>DETAIL</th><th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-b border-white/5">
                <td className="px-6 py-3 text-white/50 text-xs">{r.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="text-red-400">{r.type}</td>
                <td>{r.code || "—"}</td>
                <td className="text-white/60">IP={r.ip} · count={r.count}</td>
                <td className="px-3">
                  {tab === "open" && (
                    <div className="flex gap-2">
                      <button onClick={() => resolve(r.id, "resolved")} className="neon-btn px-3 py-1 text-xs">RESOLVE</button>
                      <button onClick={() => resolve(r.id, "dismissed")} className="ghost-btn px-3 py-1 text-xs text-white">DISMISS</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-6 py-6 text-white/40">All clear.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
